import React, { useEffect, useMemo, useState } from "react";
import "rodal/lib/rodal.css";
import "../css/tabs.css";
import "../css/rodal.css";
import commentService from "../services/comment";
import { swalError } from "../utils/swal";
import session from "../services/session";
import io from "socket.io-client";
import moment from "moment";
import CommentBox from "./CommentBox";
import collaborationService from "../services/collaboration";
import projectService from "../services/project";
import Swal from "sweetalert2";
import TextAreaMention from "./TextAreaMention/TextAreaMention";
import styled from "styled-components/macro";

const socket = io(process.env.REACT_APP_API_URL, { transports: ["websocket"] });
socket.on("connect", () => {
  // console.log("Connected to SocketIO Server.");
});

export default function ContentComments(props) {
  const [comment, setComment] = useState("");
  const [comments, setComments] = useState([]);
  // const [counter, setCounter] = useState(0);
  // const [commentToUpdate, setCommentToUpdate] = useState(null);
  const [message, setMessage] = useState("");
  const [id, setId] = useState(``);
  const [project, setProject] = useState(null);
  const [memberList, setMemberList] = useState([]);
  const [activeComment, setActiveComment] = useState(null);

  useEffect(() => {
    reloadProject();
  }, []);

  useEffect(() => {
    const projectId = window.location.href.split("/").pop();
    if (projectId && projectId.length === 24) {
      collaborationService
        .getCollaboratorsNamesByProject(projectId)
        .then((result) => {
          setMemberList(result.data);
        });
    }
  }, []);

  useEffect(() => {
    setComments([]);
    setMessage("Loading comments...");
    const moodboardId = props.id;
    socket.emit(`init-comments`, moodboardId);

    socket.off(`moodboard-comment-init-data`);
    socket.on(`moodboard-comment-init-data`, (data) => {
      setComments(data);
      if (data.length === 0) setMessage("No comments found.");
    });

    socket.off(`remote-update-comments`);
    socket.on(`remote-update-comments`, (data) => {
      setComments(data);
      if (data.length === 0) setMessage("No comments found.");
    });

    return () => {
      socket.emit(`disconnect-comments`, moodboardId);
    };
  }, [props.id]);

  const deleteCommentById = (id, rootId) => {
    if (rootId) {
      socket.emit(`delete-comment`, {
        commentId: id,
        moodboardId: props.id,
        rootId: rootId,
      });
    } else {
      socket.emit(`delete-comment`, {
        commentId: id,
        moodboardId: props.id,
      });
    }
    socket.emit(`get-comments`, props.id);
  };

  const reloadComments = async () => {
    if (!props.id) return;
    await commentService.getByMoodboard(props.id).then((result) => {
      if (result.error) {
        swalError(result.error);
        return;
      }
      setComments(result.data);
      setMessage("No comments found.");
    });
  };

  const renderComments = () => {
    return comments.map((comment, index) => (
      <CommentBox
        activeComment={activeComment}
        setActiveComment={setActiveComment}
        key={comment._id}
        comment={comment}
        reloadComments={reloadComments}
        setCommentToUpdate={(e, obj) => {
          // setId(obj.id);
          // setComment(obj.text);
          // setCommentToUpdate(obj);
          handleComment(e, obj.id, obj.text, false, undefined, obj?.rootId);
        }}
        setCommentToReply={(e, obj) => {
          handleComment(e, obj.id, obj.text, true, index);
        }}
        deleteComment={deleteCommentById}
        memberList={memberList}
      />
    ));
  };

  const reset = () => {
    document.getElementById("txt-comment-id").value = ``; //eror
    document
      .getElementsByClassName("tagify--mix")[0]
      .classList.remove("is-invalid");
    setComment("");
    setId("");
  };

  const handleComment = async (e, idEdit, text, isReply, index, rootId) => {
    e?.preventDefault();
    if (!(session.get("user") && session.get("user")._id !== undefined)) {
      swalError("Please log in");
      return;
    }

    const newText = (text || comment)?.replace(/\n\n$/, "");

    if (!newText || newText.length === 0) {
      document
        .getElementsByClassName("tagify--mix")[0]
        .classList.add("is-invalid");
      return;
    } else {
      document
        .getElementsByClassName("tagify--mix")[0]
        .classList.remove("is-invalid");
    }

    if (isReply) {
      const projectId = window.location.href.split("/").pop();
      const moodboardId = props.id;

      const newReply = {
        _id: Math.random().toString(36).substring(7),
        text: newText,
        moodboardId: moodboardId,
        projectId: projectId,
        type: "moodboard",
        date: moment().format(),
        userId: {
          active: true,
          email: session.get("user").email,
          fullname: session.get("user").fullname,
          _id: session.get("user")._id,
        },
      };
      const newComments = [...comments];
      if (newComments[index]?.replies) {
        newComments[index].replies.push(newReply);
      } else {
        newComments[index] = {
          ...newComments[index],
          replies: [newReply],
        };
      }
      setComments([...newComments]);
      reset();

      socket.emit(`reply-comment`, {
        text: newText,
        moodboardId: moodboardId,
        projectId: projectId,
        type: "moodboard",
        date: moment().format(),
        ...newComments[index],
        userId: session.get("user")._id,
      });
    } else if (!idEdit || idEdit.length === 0) {
      const projectId = window.location.href.split("/").pop();
      const moodboardId = props.id;

      const newComment = {
        _id: Math.random().toString(36).substring(7),
        text: newText,
        moodboardId: moodboardId,
        projectId: projectId,
        type: "moodboard",
        date: moment().format(),
        userId: session.get("user")._id,
      };
      setComments([...comments, newComment]);
      reset();

      socket.emit(`save-comment`, {
        text: newText,
        moodboardId: moodboardId,
        projectId: projectId,
        type: "moodboard",
        date: moment().format(),
        userId: session.get("user")._id,
      });
    } else {
      reset();
      const moodboardId = props.id;
      socket.emit(`update-comment`, {
        commentId: idEdit,
        text: newText,
        moodboardId: moodboardId,
        rootId: rootId,
      });
    }
  };

  const reloadProject = async () => {
    let id = window.location.href.split("/").pop();
    if (id && id.length === 24) {
      await projectService.get(id).then((result) => {
        if (result.error) {
          swalError(result.error);
          Swal.close();
          return;
        }

        if (result.data.length === 1) {
          setProject(result.data[0]);
        }
      });
    }
  };

  const allowCollaborate = () => {
    if (project) {
      const loggedInUserId = session.get("user")._id;
      const loggedInUserEmail = session.get("user").email;
      if (!loggedInUserId || !loggedInUserEmail) {
        return false;
      }

      if (project.userId._id.toString() === loggedInUserId.toString()) {
        return true;
      }

      const collaboration = project.collaborations.find(
        (k) => k.email === loggedInUserEmail
      );
      if (collaboration) {
        if (
          parseInt(collaboration.accepted) === 1 &&
          parseInt(collaboration.type) === 2
        ) {
          return true;
        }
      }

      return false;
    }
  };

// const uniqueId = `id-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
  const uniqueId = useMemo(
    () => `id-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
    []
  );
  return (
    <>
      {allowCollaborate() && (
        <WrapInputComment>
          <form>
            <input type="hidden" id="txt-comment-id" value={id} />
            <TextAreaMention
              value={comment}
              setComment={setComment}
              onSubmit={handleComment}
              memberList={memberList}
              uniqueId={uniqueId}
            />
            <div className="invalid-feedback text-left">
              Please provide a text.
            </div>
          </form>
        </WrapInputComment>
      )}

      <Comments>
        {(comments.length > 0 && renderComments()) || message}
      </Comments>
    </>
  );
}

const Comments = styled.div`
  height: calc(100% - 80px);
  overflow-y: auto;

  /* ::-webkit-scrollbar {
    background: #fff;
    width: 4px;
  } */
`;

const WrapInputComment = styled.div`
  z-index: 10;
  margin-bottom: 10px;
  background-color: #12141e;
`;
